import * as React from "react";
import { Oval } from "react-loader-spinner";
import { Box } from "@mui/system";
import { SxProps, useTheme } from "@mui/material";

export const Loader: React.FC<{
  width?: number;
  height?: number;
}> = ({ width = 40, height = 40 }) => {
  const { palette } = useTheme();
  return (
    <Oval
      wrapperClass={"simple-loader"}
      width={width + "px"}
      height={height + "px"}
      color={palette.contrasting}
      secondaryColor={palette.contrasting + "33"}
      ariaLabel={"Loading..."}
    />
  );
};

export const CenteredLoader: React.FC<{
  width?: number;
  height?: number;
  sx?: SxProps;
}> = ({ width = 40, height = 40, sx }) => (
  <Box
    className={"centered-loader-wrapper"}
    sx={{
      display: "flex",
      padding: "8em 0",
      alignItems: "center",
      justifyContent: "center",
      ...(sx || {}),
    }}
  >
    <Loader width={width} height={height} />
  </Box>
);
